import PropTypes from "prop-types";
import { useMemo } from "react";
import useSegmentSummaries from "../../../hooks/useSegmentSummaries";

const LABEL_MAP = {
  "user-in-segment": "Included Segments",
  "inclusion-segment": "Included Segments",
  "exclusion-segment": "Excluded Segments",
  "attach-segment": "Attach Segment",
  "detach-segment": "Detach Segment",
};

const SegmentViewComponent = ({ segmentIds = [], customComponentName }) => {
  const { segments } = useSegmentSummaries(segmentIds);
  const selectedSegments = useMemo(() => segments || [], [segments]);
  const labelText = LABEL_MAP[customComponentName] || "Segments";

  return (
    <>
      {selectedSegments && (
        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">{labelText}</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {selectedSegments
                ?.map((segment) => segment?.name)
                .filter(Boolean)
                .join(", ")}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

SegmentViewComponent.propTypes = {
  segmentIds: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  customComponentName: PropTypes.string,
};

export default SegmentViewComponent;
